<template>
	<div class="addzz">
		<el-dialog 
			:modal-append-to-body='true'
			width="600px"
			center
			:append-to-body='true'
			@close="closeXinde"
			:visible.sync="show">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData" style="padding-bottom: 40px;">
				<div class="xinde">
					{{ experience || ''}}
				</div>
				<img :src="item" v-for="item in imgs">
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {dygl} from '@/axios/index.js'
	let that;
	export default{
		data() {
			return{
				title:"心得体会",
				show:false,
				experience:"",
				imgs:[]
			}
		},
		created() {
			that = this;
			console.log(123)
		},
		methods:{
			openXinde(data){
				this.show = true;
				setTimeout(() =>{
					this.bindData(data)
				},1000)
			},
			closeXinde(){
				this.show = false
				this.experience = "";
			},
			bindData(data){
				dygl.selectTips({
					hyid:data.id,
					hyflag:data.flag,
					dyid:this.$route.query.id
				}).then(res => {
					if(res.code == 200){
						that.experience = res.data.experience;
						that.imgs = res.data.img;
					}else{
						
					}
				})
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss">
	.formData1{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.el-dialog__body{
		max-height: 500px !important;
		overflow-y: scroll;
		padding-top: 0px !important;
		margin-top: 0 !important;
	}
	.xinde{
		min-height: 300px;
		overflow-y: scroll;
		line-height: 30px;
		font-size: 14px;
		img{
			width: 50%;
			margin: 20px auto;
		}
	}
</style>
